

// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
import { IApiAction } from '../utils/data-service';
export namespace Models {
	/**
	 * To improve build and incremental build times we transpile modules using TS transpileOnly mode. It essentially builds one file at a time
	 * Using transpileOnly with emitDecoratorMetadata flag sometimes causes issues when a type or an interface is used as a property type on a decorated property
	 * Example typescript:
	 * import {Models} from '../ags-generated';
	 * import AgsViewModel = Models.AgsViewModel;
	 * export class AgsStore {
	 *   @observable model: AgsViewModel;
	 * }
	 * Generated javascript:
	 * var ags_generated_1 = __webpack_require__(<webpackModuleId>);
	 * var AgsViewModel = ags_generated_1.Models.AgsViewModel;
	 * the previous line will result in runtime error if Models does not export anything
	 * In order to avoid runtime errors accessing undefined Models let's export dummy variable
	 */
	export const __dummy = true;
	export interface ConversionRequestModel {
		CommunityMemberId: number;
		Name: string;
	}
	export interface ConversionCheckModel {
		CommunityMemberId: number;
	}
	export interface MemberSearchRequestModel {
		Query: string;
		Skip: number;
	}
	export interface CommunityMemberByNameForOrganizationConversionSearchResult {
		HasMorePages: boolean;
		SearchResults: CommunityMemberSearchForOrganizationalConversionByNameRow[];
	}
	export interface CommunityMemberSearchForOrganizationalConversionByNameRow {
		CommunityMemberId: number;
		IsRegistered: boolean;
		CommunityMemberFirstName: string;
		CommunityMemberLastName: string;
		CommunityMemberEmailAddress: string;
		CommunityMemberMobileNumber: string;
		CommunityMemberTimeZoneId: string;
		CommunityMemberLockVersion: number;
		CommunityMemberAddressLine1: string;
		CommunityMemberAddressLine2: string;
		CommunityMemberAddressCity: string;
		CommunityMemberAddressPostCode: string;
		CommunityMemberAddressState: string;
		CommunityMemberAddressCountry: Country;
		CommunityMemberLastPaymentOn: Date;
		CommunityMemberType: CommunityMemberType;
		OrganizationId: number;
		EligibleForConversion: boolean;
	}
	export enum CommunityMemberType {
		Unknown = 0, Individual = 1, Organization = 2,
	}
	export enum Country {
		NZ = 0, AU = 1, US = 2, AF = 4, AL = 8, AQ = 10, DZ = 12, AS = 16, AD = 20, AO = 24, AG = 28, AZ = 31, AR = 32, AT = 40, BS = 44, BH = 48, BD = 50, AM = 51, BB = 52, BE = 56, BM = 60, BT = 64, BO = 68,
		BA = 70, BW = 72, BV = 74, BR = 76, BZ = 84, IO = 86, SB = 90, VG = 92, BN = 96, BG = 100, MM = 104, BI = 108, BY = 112, KH = 116, CM = 120, CA = 124, CV = 132, KY = 136, CF = 140, LK = 144, TD = 148, CL = 152,
		CN = 156, TW = 158, CX = 162, CC = 166, CO = 170, KM = 174, YT = 175, CG = 178, CD = 180, CK = 184, CR = 188, HR = 191, CU = 192, CY = 196, CZ = 203, BJ = 204, DK = 208, DM = 212, DO = 214, EC = 218, SV = 222,
		GQ = 226, ET = 231, ER = 232, EE = 233, FO = 234, FK = 238, GS = 239, FJ = 242, FI = 246, AX = 248, FR = 250, GF = 254, PF = 258, TF = 260, DJ = 262, GA = 266, GE = 268, GM = 270, PS = 275, DE = 276, GH = 288,
		GI = 292, KI = 296, GR = 300, GL = 304, GD = 308, GP = 312, GU = 316, GT = 320, GN = 324, GY = 328, HT = 332, HM = 334, VA = 336, HN = 340, HK = 344, HU = 348, IS = 352, IN = 356, ID = 360, IR = 364, IQ = 368,
		IE = 372, IL = 376, IT = 380, CI = 384, JM = 388, JP = 392, KZ = 398, JO = 400, KE = 404, KP = 408, KR = 410, KW = 414, KG = 417, LA = 418, LB = 422, LS = 426, LV = 428, LR = 430, LY = 434, LI = 438, LT = 440,
		LU = 442, MO = 446, MG = 450, MW = 454, MY = 458, MV = 462, ML = 466, MT = 470, MQ = 474, MR = 478, MU = 480, MX = 484, MC = 492, MN = 496, MD = 498, ME = 499, MS = 500, MA = 504, MZ = 508, OM = 512, NA = 516,
		NR = 520, NP = 524, NL = 528, CW = 531, AW = 533, SX = 534, BQ = 535, NC = 540, VU = 548, NI = 558, NE = 562, NG = 566, NU = 570, NF = 574, NO = 578, MP = 580, UM = 581, FM = 583, MH = 584, PW = 585, PK = 586,
		PA = 591, PG = 598, PY = 600, PE = 604, PH = 608, PN = 612, PL = 616, PT = 620, GW = 624, TL = 626, PR = 630, QA = 634, RE = 638, RO = 642, RU = 643, RW = 646, BL = 652, SH = 654, KN = 659, AI = 660, LC = 662,
		MF = 663, PM = 666, VC = 670, SM = 674, ST = 678, SA = 682, SN = 686, RS = 688, SC = 690, SL = 694, SG = 702, SK = 703, VN = 704, SI = 705, SO = 706, ZA = 710, ZW = 716, ES = 724, SS = 728, SD = 729, EH = 732,
		SR = 740, SJ = 744, SZ = 748, SE = 752, CH = 756, SY = 760, TJ = 762, TH = 764, TG = 768, TK = 772, TO = 776, TT = 780, AE = 784, TN = 788, TR = 792, TM = 795, TC = 796, TV = 798, UG = 800, UA = 804, MK = 807,
		EG = 818, GB = 826, GG = 831, JE = 832, IM = 833, TZ = 834, VI = 850, BF = 854, UY = 858, UZ = 860, VE = 862, WF = 876, WS = 882, YE = 887, ZM = 894, XK = 999, __ = -2, Unsupported = -1,
	}
	export interface CommunityMemberModel {
		CommunityMemberId: number;
		FirstName: string;
		LastName: string;
		EmailAddress: string;
		MobileNumber: string;
		Address: CommunityAddressModel;
		TimeZoneId: string;
		LockVersion: number;
		LastPaymentOnUtc: Date;
		LastPaymentOnLocal: Date;
		LinkedPersons: PersonModel[];
		CommunityMemberType: CommunityMemberType;
		PaymentLabel: PaymentLabel;
	}
	export interface PaymentLabel {
		NounSentenceCase: string;
		NounPluralSentenceCase: string;
		VerbSentenceCase: string;
		VerbAppliedSentenceCase: string;
		NounLowerCase: string;
		NounPluralLowerCase: string;
		VerbLowerCase: string;
		VerbAppliedLowerCase: string;
		VerbPresentTenseSentenceCase: string;
		VerbPresentTenseLowerCase: string;
		VerbPastTenseSentenceCase: string;
		VerbPastTenseLowerCase: string;
		PayerSentenceCase: string;
		PayerLowerCase: string;
		PayerPluralSentenceCase: string;
		PayerPluralLowerCase: string;
		ActionSentenceCase: string;
		ActionLowerCase: string;
		ActionPluralSentenceCase: string;
		ActionPluralLowerCase: string;
		NonCashNounSentenceCase: string;
		NonCashNounLowerCase: string;
		NonCashPluralSentenceCase: string;
		NonCashPluralLowerCase: string;
		TextGivingFeatureName: string;
		GiftEntryFeatureName: string;
	}
	export interface PersonModel {
		PersonId: number;
		FirstName: string;
		LastName: string;
		EmailAddress: string;
		EmailAddressVerified: boolean;
		MobileNumber: string;
		MobileNumberVerified: boolean;
		Address: CommunityAddressModel;
		LastPaymentOnUtc: Date;
		LastPaymentOnLocal: Date;
		CommunityMemberType: CommunityMemberType;
	}
	export interface CommunityAddressModel {
		Line1: string;
		Line2: string;
		City: string;
		State: string;
		Postcode: string;
		Country: Country;
		DisplayAddress: string;
		PostalCodeLabel: string;
	}
	export enum CommunityMemberSearchOrder {
		FirstName = 1, LastName = 2, EmailAddress = 3, MobileNumber = 4, LastPaymentOn = 5,
	}
	export interface CountryViewModel {
		CommonName: string;
		CallingCode: string;
		CCA2: string;
		CCN3: Country;
		CCN3DisplayLabel: string;
		CCA3: string;
		MobilePlaceHolder: string;
		PostalCodeRegex: string;
		PostalCodeCommonName: string;
	}
	export interface UngroupPersonResponseModel {
		OldCommunityMember: CommunityMemberModel;
		TargetCommunityMember: CommunityMemberModel;
	}
	export interface UngroupPersonRequestModel {
		RemoveFromCommunityMemberId: number;
		PersonId: number;
	}
	export interface StatementInformation {
		StatementId: number;
		Version: number;
		CreatedOn: Date;
		EmailedOn: Date;
		CreatedBy: string;
		CompletedOn: Date;
		DownloadToken: string;
		NoPaymentsFound: boolean;
	}
	export interface GivingStatementsByNameAndPreviewabilityResponseModel {
		Name: string;
		Type: string;
		PeriodFrom: Date;
		PeriodTo: Date;
		Id: number;
		Statements: StatementModel[];
		CanPreview: boolean;
		CommunityMemberId: number;
	}
	export interface StatementModel {
		StatementId: number;
		Version: number;
		CreatedOn: string;
		EmailedOn: string;
		CompletedOn: string;
		CreatedBy: string;
		DownloadUrl: string;
		NoPaymentsFound: boolean;
	}
	export interface RegenerateCustomStatementRequestModel {
		CommunityMemberId: number;
		GivingStatementRunId: number;
	}
	export interface GivingStatementsRequestModel {
		CommunityMemberId: number;
	}
	export interface MergeCommunityMembersResponseModel {
		OldCommunityMember: CommunityMemberModel;
		TargetCommunityMember: CommunityMemberModel;
	}
	export interface MergeCommunityMembersRequestModel {
		PeopleToMove: PersontoMove[];
		CommunityMemberToAssimilate: number;
		CommunityMemberToMergeInto: number;
	}
	export interface PersontoMove {
		PersonId: number;
	}
	export interface GroupPersonWithCommunityMemberResponseModel {
		OldCommunityMember: CommunityMemberModel;
		TargetCommunityMember: CommunityMemberModel;
	}
	export interface GroupPersonWithCommunityMemberRequestModel {
		PersonId: number;
		NewCommunityMemberId: number;
		OldCommunityMemberId: number;
	}
	export interface SearchRequestModel {
		Query: string;
		Skip: number;
		OrderBy: string;
		OrderDirection: string;
		ExcludeResultsWithEmail: boolean;
		ExcludeResultsWithAddress: boolean;
	}
	export interface EditCommunityMemberRequestModel {
		CommunityMemberId: number;
		FirstName: string;
		LastName: string;
		EmailAddress: string;
		MobileNumber: string;
		Address: CommunityAddressModel;
		LockVersion: number;
		CommunityMemberType: CommunityMemberType;
	}
	export interface InitViewModel {
		Countries: CountryViewModel[];
		LinkBackToGivingStatements: boolean;
		EnableFeatureOrganizationalGiving: boolean;
		PaymentLabel: PaymentLabel;
		DisableCommunityMemberDragAndDrop: boolean;
	}
	export interface CommunityMemberSearchResult {
		HasMorePages: boolean;
		SearchResults: CommunityMemberModel[];
	}
	export const CommunityMemberApiConfig = {
		defaultBaseUrl: () => location.pathname.match(new RegExp('/pushpay/portal/\\d+', 'i'))[0],
		actions: {
			updateCommunityMember: <IApiAction<{model: EditCommunityMemberRequestModel}, CommunityMemberModel>>{
				url: (data) => `/communitymembers/ajax/UpdateCommunityMember`,
			},
			searchMembersForOrganizationalConversionByName: <IApiAction<{model: MemberSearchRequestModel}, CommunityMemberByNameForOrganizationConversionSearchResult>>{
				url: (data) => `/communitymembers/ajax/SearchMembersForOrganizationalConversionByName`,
			},
			convertToOrganizationEligibilityCheck: <IApiAction<{conversionRequestModel: ConversionCheckModel}, boolean>>{
				url: (data) => `/communitymembers/ajax/ConvertToOrganizationEligibilityCheck`,
			},
			convertToOrganization: <IApiAction<{conversionRequestModel: ConversionRequestModel}, boolean>>{
				url: (data) => `/communitymembers/ajax/ConvertToOrganization`,
			},
		},
		urls: {
		},
	};
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export namespace ModelMetadata {
	export class MetadataArrayOf<T> {
		metadata: T;

		constructor(metadata: T) {
			this.metadata = metadata;
		}

		at(index: number): T {
			return this.metadata;
		}
	}

	export interface IPropertyMetadata {
		propertyName: string;
		displayName?: string;
		placeholder?: string;
		validationRules?: { [rule: string]: any };
		modelMetadata?: { [name: string] :IPropertyMetadata};
	}

	export let EditCommunityMemberRequestModel = {
		CommunityMemberId: {
			propertyName: "CommunityMemberId",
			validationRules: {
				number: {
					errorMessage: "The field CommunityMemberId must be a number.",
				},
				required: {
					errorMessage: "The CommunityMemberId field is required.",
				},
			},
		},
		FirstName: {
			propertyName: "FirstName",
			displayName: "First name",
			validationRules: {
				length: {
					errorMessage: "The field First name must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
				required: {
					errorMessage: "The First name field is required.",
				},
			},
		},
		LastName: {
			propertyName: "LastName",
			displayName: "Last name",
			validationRules: {
				length: {
					errorMessage: "The field Last name must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
			},
		},
		EmailAddress: {
			propertyName: "EmailAddress",
			displayName: "Email",
			validationRules: {
				email: {
					errorMessage: "The Email field is not a valid e-mail address.",
				},
				length: {
					errorMessage: "The field Email must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
			},
		},
		MobileNumber: {
			propertyName: "MobileNumber",
			displayName: "Mobile",
			validationRules: {
				regex: {
					errorMessage: "The Mobile field is not a valid mobile number",
					parameters: {
						pattern: "^\\+?[0-9-() ]{7,20}$",
					},
				},
				skipsanitization: {},
			},
		},
		Address: {
			propertyName: "Address",
			displayName: "Mailing address",
			get modelMetadata() {
				return ModelMetadata.CommunityAddressModel;
			},
		},
		LockVersion: {
			propertyName: "LockVersion",
			validationRules: {
				number: {
					errorMessage: "The field LockVersion must be a number.",
				},
				range: {
					errorMessage: "The field LockVersion must be between 0 and 2147483647.",
					parameters: {
						max: 2147483647,
						min: 0,
					},
				},
				required: {
					errorMessage: "The LockVersion field is required.",
				},
			},
		},
		CommunityMemberType: {
			propertyName: "CommunityMemberType",
			validationRules: {
				required: {
					errorMessage: "The CommunityMemberType field is required.",
				},
			},
		},
	};
	export let CommunityAddressModel = {
		Line1: {
			propertyName: "Line1",
			displayName: "Address line 1",
			placeholder: "Address line 1",
			validationRules: {
				length: {
					errorMessage: "Address line 1 must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		Line2: {
			propertyName: "Line2",
			displayName: "Address line 2",
			placeholder: "Address line 2",
			validationRules: {
				length: {
					errorMessage: "Address line 2 must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		City: {
			propertyName: "City",
			displayName: "City",
			placeholder: "City",
			validationRules: {
				length: {
					errorMessage: "City must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		State: {
			propertyName: "State",
			displayName: "State",
			placeholder: "State",
			validationRules: {
				length: {
					errorMessage: "State must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		Postcode: {
			propertyName: "Postcode",
			displayName: "Zip / Postcode",
			placeholder: "Zip / Postcode",
			validationRules: {
				regex: {
					errorMessage: "Please enter a valid zip or postcode",
					parameters: {
						pattern: "^[\\w\\s-]+$",
					},
				},
			},
		},
		Country: {
			propertyName: "Country",
			displayName: "Country",
			validationRules: {
				required: {
					errorMessage: "The Country field is required.",
				},
			},
		},
		DisplayAddress: {
			propertyName: "DisplayAddress",
		},
		PostalCodeLabel: {
			propertyName: "PostalCodeLabel",
		},
	};
	export let CommunityMemberModel = {
		CommunityMemberId: {
			propertyName: "CommunityMemberId",
			validationRules: {
				number: {
					errorMessage: "The field CommunityMemberId must be a number.",
				},
				required: {
					errorMessage: "The CommunityMemberId field is required.",
				},
			},
		},
		FirstName: {
			propertyName: "FirstName",
		},
		LastName: {
			propertyName: "LastName",
		},
		EmailAddress: {
			propertyName: "EmailAddress",
		},
		MobileNumber: {
			propertyName: "MobileNumber",
		},
		Address: {
			propertyName: "Address",
			get modelMetadata() {
				return ModelMetadata.CommunityAddressModel;
			},
		},
		TimeZoneId: {
			propertyName: "TimeZoneId",
		},
		LockVersion: {
			propertyName: "LockVersion",
			validationRules: {
				number: {
					errorMessage: "The field LockVersion must be a number.",
				},
				required: {
					errorMessage: "The LockVersion field is required.",
				},
			},
		},
		LastPaymentOnUtc: {
			propertyName: "LastPaymentOnUtc",
			validationRules: {
				date: {
					errorMessage: "The field LastPaymentOnUtc must be a date.",
				},
				required: {
					errorMessage: "The LastPaymentOnUtc field is required.",
				},
			},
		},
		LastPaymentOnLocal: {
			propertyName: "LastPaymentOnLocal",
			validationRules: {
				date: {
					errorMessage: "The field LastPaymentOnLocal must be a date.",
				},
				required: {
					errorMessage: "The LastPaymentOnLocal field is required.",
				},
			},
		},
		LinkedPersons: {
			propertyName: "LinkedPersons",
		},
		CommunityMemberType: {
			propertyName: "CommunityMemberType",
			validationRules: {
				required: {
					errorMessage: "The CommunityMemberType field is required.",
				},
			},
		},
		PaymentLabel: {
			propertyName: "PaymentLabel",
		},
	};
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
